<template>  
  <div class="container-fluid mt-3">
    <div class="row">

      
      <div class="col-12 col-xl-4">

        <div class="card border-0">
          <div class="card-header bg-transparent"><h3 class="text-muted">Create A Quote</h3></div>

          <div class="card-body mb-4">
            <h5 class="card-title text-muted">Select a build for your quote.</h5>
            <div class="row d-flex align-items-center">
              <div class="col-12 col-xl-9">
                <v-select 
                  v-model="build_quote"
                  placeholder="Select a Build"
                  label="build_name"
                  :options= "userBuildList"
                  :reduce="userBuildList => userBuildList.id"
                  class="p-0 bg-white style-chooser">
                </v-select>
              </div>
              <div class="col-12 col-xl-3 mt-2 mt-xl-0">
                <button v-if="build_quote != ''" @click="createQuote" class="btn btn-primary">Create</button>
              </div>
            </div>
          </div>

          
        </div>

      <hr class="d-block d-xl-none">
      </div> <!-- end build create col -->
      <div class="col-12 col-xl-8 border-xl-left vh-100" style="max-height: 600px">
        <div class="card border-0">
          <div class="card-header bg-transparent"><h3 class="text-muted">Your Quotes</h3></div>

          <slot v-if="userQuoteComp == 0">
            <div v-if="userQuoteList.length < 1" class="card-body mt-4">
              <div class="col-12 d-flex justify-content-center align-items-center">
                <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style=""/>
                <span class="ml-3 h4" style="color:#0E1698">Loading Quotes...</span>
              </div>
            </div>
          </slot>

          <slot v-if="userQuoteComp == 1">
            <div v-if="userQuoteList.length == 0" class="card-body mt-4">
              <div class="col-12 text-center">
                <h3 class="text-muted">No Existing Quotes were Found.</h3>
              </div>
            </div>

            <div v-if="userQuoteList.length > 0" class="card-body mb-4">

              <div class="d-none d-lg-block">
                <v-client-table :data="userQuoteList" :columns="tableColumns" :options="tableOptions">
                  <div slot="slot1" slot-scope="props">
                    <a href="#" class="" @click="viewQuote(props.row.id)"><i class="fa fa-search" aria-hidden="true"></i></a>
                  </div>
                  <div slot="slot2" slot-scope="props">
                    {{ props.row.build.build_price | currency }}
                  </div>
                  <div slot="slot3" slot-scope="props">
                    {{ props.row.created_at | moment("MM-DD-YYYY") }}
                  </div>
                </v-client-table>
              </div>  

              <div class="d-block d-lg-none list-group">
                <v-client-table :data="userQuoteList" :columns="tableColumns2" :options="tableOptions2">
                  <div slot="slot1"  slot-scope="props" class="list-group-item">
                    <h5 class="mb-1">{{ props.row.org.org_title }}</h5>
                    <div class="mb-1">{{ props.row.build.product_name}}</div>
                    <div class="d-flex w-100 justify-content-between">
                      <small class="text-muted">{{ props.row.build.build_price | currency }}</small>
                      <small class="text-muted">{{ props.row.created_at | moment("MM-DD-YYYY") }}</small>
                    </div>
                    <hr>
                    <div class="text-center"><a href="#" class="" @click="viewQuote(props.row.id)"><i class="fa fa-search" aria-hidden="true"></i></a></div>
                  </div>
                </v-client-table>
              </div>


            </div>
          </slot>
          
        </div>
      </div> <!-- end build list col -->
    </div><!--  end intial row -->

  </div><!--  end container-fluid div -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../stores/quote-builder-main-store.js'


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      build_quote: '',

      tableColumns: ['id', 'org.org_title', 'build.product_name', 'slot2', 'slot3', 'slot1'],
      tableOptions: {
        skin: 'table table-sm table-hover border-0 vuetable2',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 18,
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          id: '',
          'org.org_title': '',
          'build.product_name': '',
          slot2: '', 
          slot3: '',
          slot1: '',
        }, 
        headings: { 
          id: '',
          'org.org_title': 'Organization',
          'build.product_name': 'Product',
          slot2: 'Price', 
          slot3: 'Created',
          slot1: '',
        },
      },
      tableColumns2: ['slot1'],
      tableOptions2: {
        skin: 'table table-sm table-hover border-0 vuetable2',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 4,
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          slot1: '',
        }, 
        headings: {
          slot1: '',
        },
      }
    }
  },
  computed: {
    userQuoteComp () { return this.$store.state.userQuoteComp },
    userQuoteList () { return this.$store.state.userQuoteList },

    userBuildList () { return this.$store.state.userBuildList },
    allProdList () { return this.$store.state.allProdList },
    productComp () { return this.$store.state.productComp },
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },

    createQuote() {
      var _this = this;
      if(_this.build_quote == ''){
        return false;
      }
      var setup = ['', _this.build_quote];
      _this.getMainView('quote-builder', '', '', setup);
    },
    viewQuote(x) {
      var _this = this;
      var setup = ['', x];
      _this.getMainView('quote-view', '', '', setup);
    },
  },    
  components:{
    ScalingSquaresSpinner,
  },
  filters: {

  }
}
</script>
